export function getGradeColor(grade) {
  switch (grade) {
    case "A":
      return "green";
    case "B":
      return "#66BB6A";
    case "C":
      return "#FFC107";
    case "D":
      return "darkOrange";
    case "F":
      return "red";
    default:
      return "black";
  }
}

export function getTrackingColor(trackingNumber) {
  if (trackingNumber >= 0) {
    return "green";
  } else if (trackingNumber >= -4) {
    return "#FFC107";
  } else {
    return "red";
  }
}
